/**
 * London Smoke & Cure — short-lived client caches for Njord registry GETs.
 * Overview / Devices / Alerts / desktop notifier all poll sensors+rooms; without a
 * shared TTL they each hit Cloud Run → full Firestore collection reads.
 */

const DEFAULT_TTL_MS = 45_000;

/**
 * @template T
 * @param {number} [ttlMs]
 */
export function createNjordGetCache(ttlMs = DEFAULT_TTL_MS) {
    /** @type {Map<string, { at: number, value: T }>} */
    const map = new Map();

    return {
        /**
         * @param {string} key
         * @param {() => Promise<T>} loader
         * @param {{ force?: boolean }} [opts]
         * @returns {Promise<T>}
         */
        async get(key, loader, opts = {}) {
            const now = Date.now();
            const hit = map.get(key);
            if (!opts.force && hit && now - hit.at < ttlMs) {
                return hit.value;
            }
            const value = await loader();
            map.set(key, { at: Date.now(), value });
            return value;
        },
        /** @param {string} [key] */
        invalidate(key) {
            if (key == null) map.clear();
            else map.delete(key);
        },
    };
}

export const njordSensorsGetCache = createNjordGetCache(DEFAULT_TTL_MS);
export const njordRoomsGetCache = createNjordGetCache(DEFAULT_TTL_MS);
